import React from 'react'
import { Icon } from '@wmgtech/legato'

export const projectDetailsNavTabs = (
  projectFeedTotal: number,
  projectProductsTotal: number,
  projectTourTotal: number,
  isLocalized?: boolean
) => [
  { label: 'Stories', value: 'stories', ...(projectFeedTotal > 0 && { count: projectFeedTotal }) },
  { label: `${!isLocalized ? 'Local ' : ''}Project Information`, value: 'projectInfo' },
  { label: 'Products', value: 'products', count: projectProductsTotal },
  { label: 'Tour', value: 'tour', count: projectTourTotal }
]

export const localizeProjectDetailsNavTabs = (projectFeedTotal: number, projectTourTotal: number) => [
  { label: 'Stories', value: 'stories', ...(projectFeedTotal > 0 && { count: projectFeedTotal }) },
  { label: 'Project Information', value: 'projectInfo' },
  { label: 'Tour', value: 'tour', count: projectTourTotal }
]

export const getFieldTitle = (field: 'info' | 'team_info', isGlobal = false): JSX.Element | string => {
  const localTitles = {
    info: 'Local Project Information',
    team_info: 'Local Team Information'
  }
  const globalTitles = {
    info: <>Global Project Information <Icon prefix="fas" name="badge-check" className="icon-global" /></>,
    team_info: <>Global Team Information <Icon prefix="fas" name="badge-check" className="icon-global" /></>
  }
  if (isGlobal) {
    return globalTitles[field]
  } else {
    return localTitles[field]
  }
}
